import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { formatNumber } from "../../Utils/formatters";
import "./GenderChart.css";

function GenderChart({ data }) {
  const defaultData = [
    { name: "Male", value: 0, percentage: 0, color: "#1890ff" },
    { name: "Female", value: 0, percentage: 0, color: "#eb2f96" },
  ];

  // ✅ Backend data aaye to use karo, warna default
  const chartData =
    data && data.length > 0
      ? data.map((item) => ({
          ...item,
          color:
            item.name === "Male"
              ? "#1890ff"
              : item.name === "Female"
              ? "#eb2f96"
              : "#faad14",
        }))
      : defaultData;

  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="gender-chart-card">
      <h3 className="chart-title">Gender Distribution</h3>

      <div className="gender-chart-content">
        <div className="gender-chart-wrapper">
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={55}
                outerRadius={80}
                paddingAngle={3}
                dataKey="value"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                formatter={(value) => formatNumber(value)}
                contentStyle={{
                  borderRadius: "10px",
                  border: "1px solid #f0f0f0",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
                }}
              />
            </PieChart>
          </ResponsiveContainer>

          <div className="chart-center-content">
            <p className="center-label">Total Users</p>
            <h2 className="center-value">{formatNumber(total)}</h2>
          </div>
        </div>

        <div className="gender-legend">
          {chartData.map((item, index) => (
            <div key={index} className="legend-item">
              <div className="legend-info">
                <span
                  className="legend-dot"
                  style={{ background: item.color }}
                ></span>
                <span className="legend-name">{item.name}</span>
              </div>
              <div className="legend-values">
                <strong>{formatNumber(item.value)}</strong>
                <span className="legend-percent">
                  ({item.percentage ?? 0}%)
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GenderChart;